import arActivityLogs from './ar/activity-logs.json'
import arAdministration from './ar/administration.json'
import arAreas from './ar/areas.json'
import arAuth from './ar/auth.json'
import arCommon from './ar/common.json'
import arComponents from './ar/components.json'
import arDashboard from './ar/dashboard.json'
import arDrivers from './ar/drivers.json'
import arEnums from './ar/enums.json'
import arLayout from './ar/layout.json'
import arMasterImport from './ar/master-import.json'
import arNotifications from './ar/notifications.json'
import arPublic from './ar/public.json'
import arRentals from './ar/rentals.json'
import arReports from './ar/reports.json'
import arRequests from './ar/requests.json'
import arRiders from './ar/riders.json'
import arRoutes from './ar/routes.json'
import arServices from './ar/services.json'
import arSettings from './ar/settings.json'
import arSystemHealth from './ar/system-health.json'
import arTenants from './ar/tenants.json'
import arTickets from './ar/tickets.json'
// Import Arabic translations
import arTransportationFieldsGroup from './ar/transportation-fields-group.json'
import arTrips from './ar/trips.json'
import arVehicles from './ar/vehicles.json'
import enActivityLogs from './en/activity-logs.json'
import enAdministration from './en/administration.json'
import enAreas from './en/areas.json'
import enAuth from './en/auth.json'
import enCommon from './en/common.json'
import enComponents from './en/components.json'
import enDashboard from './en/dashboard.json'
import enDrivers from './en/drivers.json'
import enEnums from './en/enums.json'
import enLayout from './en/layout.json'
import enMasterImport from './en/master-import.json'
import enNotifications from './en/notifications.json'
import enPublic from './en/public.json'
import enRentals from './en/rentals.json'
import enReports from './en/reports.json'
import enRequests from './en/requests.json'
import enRiders from './en/riders.json'
import enRoutes from './en/routes.json'
import enServices from './en/services.json'
import enSettings from './en/settings.json'
import enSystemHealth from './en/system-health.json'
import enTenants from './en/tenants.json'
import enTickets from './en/tickets.json'
// Import English translations
import enTransportationFieldsGroup from './en/transportation-fields-group.json'
import enTrips from './en/trips.json'
import enVehicles from './en/vehicles.json'

// Import feature-specific translations as they're created
// Example:
// import enTenants from './en/tenants.json'
// import arTenants from './ar/tenants.json'
// import enDrivers from './en/drivers.json'
// import arDrivers from './ar/drivers.json'

/**
 * Consolidated messages object for all locales.
 * Each locale's messages are composed by merging feature-based translation files.
 *
 * To add a new feature:
 * 1. Create en/{feature}.json and ar/{feature}.json
 * 2. Import them above
 * 3. Add them to the spread operators below
 */
export const messages = {
  ar: {
    ...arActivityLogs,
    ...arTransportationFieldsGroup,
    ...arAdministration,
    ...arAreas,
    ...arPublic,
    ...arRentals,
    ...arReports,
    ...arAuth,
    ...arCommon,
    ...arComponents,
    ...arDashboard,
    ...arDrivers,
    ...arEnums,
    ...arLayout,
    ...arMasterImport,
    ...arNotifications,
    ...arRequests,
    ...arRiders,
    ...arRoutes,
    ...arServices,
    ...arSettings,
    ...arSystemHealth,
    ...arTenants,
    ...arTickets,
    ...arTrips,
    ...arVehicles
  },
  en: {
    ...enActivityLogs,
    ...enTransportationFieldsGroup,
    ...enAdministration,
    ...enAreas,
    ...enPublic,
    ...enRentals,
    ...enReports,
    ...enAuth,
    ...enCommon,
    ...enComponents,
    ...enDashboard,
    ...enDrivers,
    ...enEnums,
    ...enLayout,
    ...enMasterImport,
    ...enNotifications,
    ...enRequests,
    ...enRiders,
    ...enRoutes,
    ...enServices,
    ...enSettings,
    ...enSystemHealth,
    ...enTenants,
    ...enTickets,
    ...enTrips,
    ...enVehicles
  }
} as const
